import { useCallback } from "react";
import { useApolloClient, gql } from "@apollo/client";
import { UpdateToolsIAVariables } from "../__generated__/gql-types/UpdateToolsIA";

const UseUpdateLiteracy = () => {
  const client = useApolloClient();
  return useCallback(
    async (input: UpdateToolsIAVariables) => {
      return await client.mutate({
        mutation: UPDATE_TOOLS_IA,
        fetchPolicy: "no-cache",
        variables: input,
      });
    },
    [client]
  );
};

export default UseUpdateLiteracy;

const UPDATE_TOOLS_IA = gql`
  mutation UpdateToolsIA($updateToolsIaId: ID!, $toolsIaInput: ToolsIAInput!) {
    updateToolsIA(id: $updateToolsIaId, toolsIAInput: $toolsIaInput) {
      cover
      cover_en
      created_at
      deleted_at
      description
      description_en
      forms {
        example_text
        label
        number_of_lines
        section
      }
      forms_en {
        example_text
        label
        number_of_lines
        section
      }
      id
      prompt
      prompt_en
      title
      title_en
      updated_at
    }
  }
`;
